import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Globals } from '../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class AuditService {
  private url: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.url = globals.url + 'audit/';
  }
  public getUserAudits(page?, limit?, filters?) {
    let url = this.url + 'users';
    if (typeof page == 'number' && typeof limit == 'number') {
      url = this.prepareUrlFilters(url, { ...filters, page, limit });
    } else {
      url = this.prepareUrlFilters(url, filters);
    }
    return this.http.get(url).map((response: Response) => response.json());
  }
  public countUserAudits(filters?) {
    const url = this.prepareUrlFilters(this.url + 'users/count', filters);
    return this.http.get(url).map((response: Response) => response.json());
  }
  public getDeviceAudits(page?, limit?, filters?) {
    let url = this.url + 'devices';
    if (typeof page == 'number' && typeof limit == 'number') {
      url = this.prepareUrlFilters(url, { ...filters, page, limit });
    } else {
      url = this.prepareUrlFilters(url, filters);
    }
    return this.http.get(url).map((response: Response) => response.json());
  }
  public countDeviceAudits(filters?) {
    const url = this.prepareUrlFilters(this.url + 'devices/count', filters);
    return this.http.get(url).map((response: Response) => response.json());
  }
  public actionAuditsUsed() {
    return this.http.get(this.url + 'actions-used').map((response: Response) => response.json());
  }

  // allows search with special chars. ex: #
  private prepareUrlFilters(url, filters) {
    const params: URLSearchParams = new URLSearchParams();
    if (!filters || !Object.keys(filters).length) { return url; }
    Object.entries(filters).forEach(([key, value]) => {
      params.append(key, value.toString());
    });
    const paramsStr = params.toString();
    if (paramsStr) { url += '?' + paramsStr; }
    return url;
  }
}
